import EventBus from "../../../../util/EventBus";
import Applet from "../../Applet";
import PlatformDetailDialog from "../../../../components/PlatformDetailDialog";

const FULL = {"View": {xs: 12, sm: 12, md: 12, lg: 12, xl: 12},
              "Edit": {xs: 12, sm: 12, md: 12, lg: 12, xl: 12},
              "New":  {xs: 12, sm: 12, md: 12, lg: 12, xl: 12}};
const HALF = {"View": {xs: 12, sm: 6, md: 6, lg: 6, xl: 6},
              "Edit": {xs: 12, sm: 6, md: 6, lg: 6, xl: 6},
              "New":  {xs: 12, sm: 6, md: 6, lg: 6, xl: 6}};

/**
 * Raise a change order.
 *
 * TYPE FIRST, because it decides everything that follows: which form the change order carries, and
 * which approvers its matrix demands. Choosing it last would mean answering questions whose shape
 * had not been settled.
 *
 * THE IDENTIFIER IS NOT ASKED FOR. It comes from the type's number pool, server-side -- a
 * client-supplied identifier could name a change order that already exists.
 *
 * JUSTIFICATION AND IMPACT ARE ON THE FORM, not tucked into a later tab. ISO 13485 7.3.9 expects the
 * reason for a change and an assessment of its effect to be recorded, and a field nobody sees at the
 * moment they are thinking about the change is a field that gets filled in afterwards, badly.
 */
class ChangeOrderFormApplet extends Applet {
    state = {
        Name: "ChangeOrderFormApplet",
        Actions: {
            New: {
                Groups: [{
                    "identifier": "group1",
                    "type": "standard",
                    "selector": null,
                    "characteristics": [],
                    "membership": [
                        {id: "ObjectTypeUSID"},
                        {id: "Title"},
                        {id: "Description"},
                        {id: "Justification"},
                        {id: "ImpactAssessment"},
                    ],
                }],
            },
        },
        Layout: {},
        Controls: {
            ObjectTypeUSID: {
                id: "ObjectTypeUSID",
                enterpriseComponentAttribute: "ObjectTypeUSID",
                placement: HALF,
                errors: [{validator: "Required", value: null, errorText: "A change order type is required."}],
                csp: {autoFocus: true, multiline: false, placeholder: null, label: "Type",
                      size: "small", disabled: false},
                ip: {},
                type: "Select",
                requiresConfirmation: false,
            },
            Title: {
                id: "Title",
                enterpriseComponentAttribute: "Title",
                placement: HALF,
                errors: [{validator: "Required", value: null, errorText: "A title is required."}],
                csp: {autoFocus: false, multiline: false, placeholder: null, label: "Title",
                      size: "small", disabled: false},
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
            Description: {
                id: "Description",
                enterpriseComponentAttribute: "Description",
                placement: FULL,
                errors: [],
                csp: {autoFocus: false, multiline: true, rows: 2, placeholder: null,
                      label: "Description", size: "small", disabled: false},
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
            Justification: {
                id: "Justification",
                enterpriseComponentAttribute: "Justification",
                placement: FULL,
                errors: [],
                csp: {autoFocus: false, multiline: true, rows: 2, placeholder: null,
                      label: "Reason for the change", size: "small", disabled: false},
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
            ImpactAssessment: {
                id: "ImpactAssessment",
                enterpriseComponentAttribute: "ImpactAssessment",
                placement: FULL,
                errors: [],
                csp: {autoFocus: false, multiline: true, rows: 2, placeholder: null,
                      label: "Effect on other records, product in process, or product already delivered",
                      size: "small", disabled: false},
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
        },
    };

    cancel() {
        super.cancel();
        EventBus.components.emit("change-order-form-applet-cancel");
    };

    setAction(action) {
        super.setAction(action);
        if (action === "Save Completed") {
            EventBus.components.emit("change-order-form-applet-save");
        }
    };

    render() {
        return <PlatformDetailDialog applet={this}
                                     layout={this.state.Layout}
                                     controls={this.state.Controls}
                                     actions={this.state.Actions}
                                     title="Change order"
                                     enterpriseComponent={this.getEnterpriseComponent()}
                                     action={this.props.defaultAction}
                                     errorReportingMethod="RealTime"/>;
    }
}

export default ChangeOrderFormApplet;
